module.exports = __webpack_public_path__ + "static/media/Template-for-Floor-Plan.c6e6f883.png";